// src/assets/videos/index.ts
// 動画ファイルのインポート

// Juno関連動画
import junoTop from "./juno/top.mp4";
import junoHailuo from "./juno/hailuo.mp4";
import junoHaiper from "./juno/haiper.mp4";
import junoKling from "./juno/kling.mp4";
import junoLuma from "./juno/luma.mp4";
import junoPika from "./juno/pika.mp4";
import junoPixverse from "./juno/pixverse.mp4";
import junoRunway from "./juno/runway.mp4";
import junoVidu from "./juno/vidu.mp4";
import junoWan from "./juno/wan.mp4";
import junoHedra from "./juno/hedra.mp4";

// Juno カメラ動画
import junoCameraPanLeft from "./juno/camera/pan-left.mp4";
import junoCameraPanRight from "./juno/camera/pan-right.mp4";
import junoCameraOrbitLeft from "./juno/camera/orbit-left.mp4";
import junoCameraOrbitRight from "./juno/camera/orbit-right.mp4";
import junoCameraCraneUp from "./juno/camera/crane-up.mp4";
import junoCameraCraneDown from "./juno/camera/crane-down.mp4";
import junoCameraMoveLeft from "./juno/camera/move-left.mp4";
import junoCameraMoveRight from "./juno/camera/move-right.mp4";
import junoCameraTiltUp from "./juno/camera/tilt-up.mp4";
import junoCameraTiltDown from "./juno/camera/tilt-down.mp4";
import junoCameraPushIn from "./juno/camera/push-in.mp4";
import junoCameraPullOut from "./juno/camera/pull-out.mp4";
import junoCameraZoomIn from "./juno/camera/zoom-in.mp4";
import junoCameraZoomOut from "./juno/camera/zoom-out.mp4";
import junoCameraTracking from "./juno/camera/tracking.mp4";
import junoCameraShake from "./juno/camera/shake.mp4";
import junoCameraStatic from "./juno/camera/static.mp4";
import junoCameraWalkLeft from "./juno/camera/walk-left.mp4";
import junoCameraWalkRight from "./juno/camera/walk-right.mp4";
import junoCameraTiltUpForward from "./juno/camera/tilt-up-forward.mp4";
import junoCameraTiltDownBack from "./juno/camera/tilt-down-back.mp4";
import junoCameraStageRight from "./juno/camera/stage-right.mp4";
import junoCameraStageLeft from "./juno/camera/stage-left.mp4";
import junoCameraScenic from "./juno/camera/scenic.mp4";

// Juno Luma カメラ動画
import junoCameraLumaAerialDrone from "./juno/camera/luma/Aerial Drone.mp4";
import junoCameraLumaAerial from "./juno/camera/luma/Aerial.mp4";
import junoCameraLumaBoltCam from "./juno/camera/luma/Bolt Cam.mp4";
import junoCameraLumaCraneDown from "./juno/camera/luma/Crane Down.mp4";
import junoCameraLumaCraneUp from "./juno/camera/luma/Crane Up.mp4";
import junoCameraLumaDollyZoom from "./juno/camera/luma/Dolly Zoom.mp4";
import junoCameraLumaElevatorDoors from "./juno/camera/luma/Elevator Doors.mp4";
import junoCameraLumaEyeLevelThumbnail from "./juno/camera/luma/Eye Level Thumbnail.mp4";
import junoCameraLumaFirstPersonViewThumbnail from "./juno/camera/luma/First Person View Thumbnail.mp4";
import junoCameraLumaGroundLevelThumbnail from "./juno/camera/luma/Ground Level Thumbnail.mp4";
import junoCameraLumaHighAngleThumbnail from "./juno/camera/luma/High Angle Thumbnail.mp4";
import junoCameraLumaLowAngleThumbnail from "./juno/camera/luma/Low Angle Thumbnail.mp4";
import junoCameraLumaOrbitLeft from "./juno/camera/luma/Orbit Left.mp4";
import junoCameraLumaOrbitRight from "./juno/camera/luma/Orbit Right.mp4";
import junoCameraLumaOTSThumbnail from "./juno/camera/luma/OTS Thumbnail.mp4";
import junoCameraLumaOverhead from "./juno/camera/luma/Overhead.mp4";
import junoCameraLumaPanLeftALT from "./juno/camera/luma/Pan Left ALT.mp4";
import junoCameraLumaPanRightALT from "./juno/camera/luma/Pan Right ALT.mp4";
import junoCameraLumaPedestalDown from "./juno/camera/luma/Pedestal Down.mp4";
import junoCameraLumaPedestalUp from "./juno/camera/luma/Pedestal Up.mp4";
import junoCameraLumaPullOut from "./juno/camera/luma/Pull Out.mp4";
import junoCameraLumaPushIn from "./juno/camera/luma/Push In.mp4";
import junoCameraLumaRollLeft from "./juno/camera/luma/Roll Left.mp4";
import junoCameraLumaRollRight from "./juno/camera/luma/Roll Right.mp4";
import junoCameraLumaSelfieThumbnail from "./juno/camera/luma/Selfie Thumbnail.mp4";
import junoCameraLumaShakyCAm from "./juno/camera/luma/Shaky Cam.mp4";
import junoCameraLumaStatic from "./juno/camera/luma/Static.mp4";
import junoCameraLumaTiltDown from "./juno/camera/luma/Tilt Down.mp4";
import junoCameraLumaTiltUp from "./juno/camera/luma/Tilt Up.mp4";
import junoCameraLumaTinyPlanet from "./juno/camera/luma/Tiny Planet.mp4";
import junoCameraLumaTruckLeft from "./juno/camera/luma/Truck Left.mp4";
import junoCameraLumaTruckRight from "./juno/camera/luma/Truck Right.mp4";
import junoCameraLumaZoomIn from "./juno/camera/luma/Zoom In.mp4";
import junoCameraLumaZoomOut from "./juno/camera/luma/Zoom Out.mp4";

// トップページ関連動画
import topBrowsing from "./top/browsing.mp4";
import topEditor from "./top/editor.mp4";
import topFVZOAnimation from "./top/FVZO_animation.mp4";

// エクスポート
export const Videos = {
  juno: {
    top: junoTop,
    hailuo: junoHailuo,
    haiper: junoHaiper,
    kling: junoKling,
    luma: junoLuma,
    pika: junoPika,
    pixverse: junoPixverse,
    runway: junoRunway,
    vidu: junoVidu,
    wan: junoWan,
    hedra: junoHedra,
    camera: {
      "pan-left": junoCameraPanLeft,
      "pan-right": junoCameraPanRight,
      "orbit-left": junoCameraOrbitLeft,
      "orbit-right": junoCameraOrbitRight,
      "crane-up": junoCameraCraneUp,
      "crane-down": junoCameraCraneDown,
      "move-left": junoCameraMoveLeft,
      "move-right": junoCameraMoveRight,
      "tilt-up": junoCameraTiltUp,
      "tilt-down": junoCameraTiltDown,
      "push-in": junoCameraPushIn,
      "pull-out": junoCameraPullOut,
      "zoom-in": junoCameraZoomIn,
      "zoom-out": junoCameraZoomOut,
      tracking: junoCameraTracking,
      shake: junoCameraShake,
      static: junoCameraStatic,
      "walk-left": junoCameraWalkLeft,
      "walk-right": junoCameraWalkRight,
      "tilt-up-forward": junoCameraTiltUpForward,
      "tilt-down-back": junoCameraTiltDownBack,
      "stage-right": junoCameraStageRight,
      "stage-left": junoCameraStageLeft,
      scenic: junoCameraScenic,
    },
    lumaCamera: {
      aerialDrone: junoCameraLumaAerialDrone,
      aerial: junoCameraLumaAerial,
      boltCam: junoCameraLumaBoltCam,
      craneDown: junoCameraLumaCraneDown,
      craneUp: junoCameraLumaCraneUp,
      dollyZoom: junoCameraLumaDollyZoom,
      elevatorDoors: junoCameraLumaElevatorDoors,
      eyeLevelThumbnail: junoCameraLumaEyeLevelThumbnail,
      firstPersonViewThumbnail: junoCameraLumaFirstPersonViewThumbnail,
      groundLevelThumbnail: junoCameraLumaGroundLevelThumbnail,
      highAngleThumbnail: junoCameraLumaHighAngleThumbnail,
      lowAngleThumbnail: junoCameraLumaLowAngleThumbnail,
      orbitLeft: junoCameraLumaOrbitLeft,
      orbitRight: junoCameraLumaOrbitRight,
      otsThumbnail: junoCameraLumaOTSThumbnail,
      overhead: junoCameraLumaOverhead,
      panLeftAlt: junoCameraLumaPanLeftALT,
      panRightAlt: junoCameraLumaPanRightALT,
      pedestalDown: junoCameraLumaPedestalDown,
      pedestalUp: junoCameraLumaPedestalUp,
      pullOut: junoCameraLumaPullOut,
      pushIn: junoCameraLumaPushIn,
      rollLeft: junoCameraLumaRollLeft,
      rollRight: junoCameraLumaRollRight,
      selfieThumbnail: junoCameraLumaSelfieThumbnail,
      shakyCam: junoCameraLumaShakyCAm,
      static: junoCameraLumaStatic,
      tiltDown: junoCameraLumaTiltDown,
      tiltUp: junoCameraLumaTiltUp,
      tinyPlanet: junoCameraLumaTinyPlanet,
      truckLeft: junoCameraLumaTruckLeft,
      truckRight: junoCameraLumaTruckRight,
      zoomIn: junoCameraLumaZoomIn,
      zoomOut: junoCameraLumaZoomOut,
    },
  },
  top: {
    browsing: topBrowsing,
    editor: topEditor,
    fvzoAnimation: topFVZOAnimation,
  },
};

// 個別エクスポート
export {
  junoTop,
  junoHailuo,
  junoHaiper,
  junoKling,
  junoLuma,
  junoPika,
  junoPixverse,
  junoRunway,
  junoVidu,
  junoWan,
  junoHedra,
  junoCameraPanLeft,
  junoCameraPanRight,
  junoCameraOrbitLeft,
  junoCameraOrbitRight,
  junoCameraCraneUp,
  junoCameraCraneDown,
  junoCameraMoveLeft,
  junoCameraMoveRight,
  junoCameraTiltUp,
  junoCameraTiltDown,
  junoCameraPushIn,
  junoCameraPullOut,
  junoCameraZoomIn,
  junoCameraZoomOut,
  junoCameraTracking,
  junoCameraShake,
  junoCameraStatic,
  junoCameraWalkLeft,
  junoCameraWalkRight,
  junoCameraTiltUpForward,
  junoCameraTiltDownBack,
  junoCameraStageRight,
  junoCameraStageLeft,
  junoCameraScenic,
  topBrowsing,
  topEditor,
  topFVZOAnimation,
  junoCameraLumaAerialDrone,
  junoCameraLumaAerial,
  junoCameraLumaBoltCam,
  junoCameraLumaCraneDown,
  junoCameraLumaCraneUp,
  junoCameraLumaDollyZoom,
  junoCameraLumaElevatorDoors,
  junoCameraLumaEyeLevelThumbnail,
  junoCameraLumaFirstPersonViewThumbnail,
  junoCameraLumaGroundLevelThumbnail,
  junoCameraLumaHighAngleThumbnail,
  junoCameraLumaLowAngleThumbnail,
  junoCameraLumaOrbitLeft,
  junoCameraLumaOrbitRight,
  junoCameraLumaOTSThumbnail,
  junoCameraLumaOverhead,
  junoCameraLumaPanLeftALT,
  junoCameraLumaPanRightALT,
  junoCameraLumaPedestalDown,
  junoCameraLumaPedestalUp,
  junoCameraLumaPullOut,
  junoCameraLumaPushIn,
  junoCameraLumaRollLeft,
  junoCameraLumaRollRight,
  junoCameraLumaSelfieThumbnail,
  junoCameraLumaShakyCAm,
  junoCameraLumaStatic,
  junoCameraLumaTiltDown,
  junoCameraLumaTiltUp,
  junoCameraLumaTinyPlanet,
  junoCameraLumaTruckLeft,
  junoCameraLumaTruckRight,
  junoCameraLumaZoomIn,
  junoCameraLumaZoomOut,
};
